import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { PropertyPillFilters } from '@shared-ui/lodging-property-pill-filters';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './details/shared-ui-property-details';

interface PropertyPillFiltersWrapperProps {
  currentHotel?: CurrentHotelStore;
}

const PropertyPillFiltersWrapper: React.FC<SharedUiWrapperProps & PropertyPillFiltersWrapperProps> = ({ inputs, currentHotel }) => {
  const isDateless = currentHotel.searchCriteria.isDateless;

  if (!isDateless) {
    return null;
  }

  return (
    <UitkSpacing margin={{ block: 'six', small: { inline: 'three' }, medium: { inline: 'unset' } }}>
      <div>
        <PropertyPillFilters inputs={inputs} />
      </div>
    </UitkSpacing>
  );
};

export const SharedUiPropertyPillFiltersWrapper = withSharedUiPropertyDetails(inject('currentHotel')(observer(PropertyPillFiltersWrapper)));
SharedUiPropertyPillFiltersWrapper.displayName = 'SharedUiPropertyPillFiltersWrapper';
